module.exports = __webpack_public_path__ + "3945e7d3f448cf87739a9095a8aed32d.png";